<template lang="html">
  <div class="wrapper">
    <div id="editor">
     <vue-editor useCustomImageHandler @image-added="handleImageAdded" v-model="htmlForEditor"></vue-editor>
   </div>
   <h2>{{htmlForEditor}}</h2>
   preview
   <div class="" v-html="htmlForEditor">

   </div>
  </div>



</template>

<script>
import { VueEditor } from "vue2-editor";
import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
  components: {
   VueEditor
 },
 data() {
       return {
         htmlForEditor: ""

         }
     },
     computed:{
               ...mapGetters([
                 'prourl'



               ]),

     },
     methods: {
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
          // An example of using FormData
          // NOTE: Your key could be different such as:
          // formData.append('file', file)

          var formData = new FormData();
          formData.append("image", file);
          Editor.insertEmbed(cursorLocation, "image", this.prourl+'5');
              resetUploader();
          console.log(formData);
          // axios({
          //   url: "https://fakeapi.yoursite.com/images",
          //   method: "POST",
          //   data: formData
          // })
          //   .then(result => {
          //     let url = result.data.url; // Get url from response
          //     Editor.insertEmbed(cursorLocation, "image", url);
          //     resetUploader();
          //   })
          //   .catch(err => {
          //     console.log(err);
          //   });
        }
      }
    };
    </script>

<style lang="css" scoped>
#editor{
  margin-top: 150px
}
</style>



// WEBPACK FOOTER //
// src/components/editor.vue